export default function MediaSection() {
  const mediaItems = [
    {
      icon: 'ri-file-text-line',
      color: 'bg-blue-500',
      title: 'Folders',
      description: 'Professionele folders om uw bedrijf en diensten te presenteren',
    },
    {
      icon: 'ri-file-paper-2-line',
      color: 'bg-green-500',
      title: 'Flyers',
      description: 'Opvallende flyers voor evenementen en promoties',
    },
    {
      icon: 'ri-contacts-line',
      color: 'bg-orange-500',
      title: 'Visitekaartjes',
      description: 'Stijlvolle visitekaartjes die een blijvende indruk achterlaten',
    },
    {
      icon: 'ri-image-line',
      color: 'bg-purple-500',
      title: 'Posters',
      description: 'Grootformaat posters voor maximale zichtbaarheid',
    },
  ];

  return (
    <section className="py-20 bg-white/5 backdrop-blur-xs">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <h3 className="text-4xl font-bold text-white text-center mb-12">
            Media & Drukwerk
          </h3>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {mediaItems.map((item, index) => (
              <div
                key={index}
                className="bg-white/10 backdrop-blur-xs rounded-xl p-6 border border-white/20 hover:bg-white/15 transition-all duration-300 cursor-pointer transform hover:-translate-y-1"
              >
                <div
                  className={`w-12 h-12 ${item.color} rounded-lg flex items-center justify-center mb-4`}
                >
                  <i className={`${item.icon} text-2xl text-white`}></i>
                </div>
                <h4 className="text-xl font-semibold text-white mb-3">
                  {item.title}
                </h4>
                <p className="text-white/80 text-sm">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
